
const newModel = () => {
    return {
        trudenChieusangId: null,
        soTru: null,
        tuyenDenduongId: null,
        tenTuyenDenduong: null,
        tenLoaiTruden: null,
        loaiTrudenId: null,
        loaiDenId: null,
        tenLoaiDen: null,
        tenCongsuatDen: null,
        congsuatDenId: null,
        tinhtrangDenId: null,
        tenTinhtrangDen: null,
        tenTinhtrangTruden: null,
        tinhtrangTrudenId: null,
        gpsLong: null,
        gpsLat: null,
        ghiChu: null,
        stt: "0",
        enabled: true,
        dateCreated: null,
        dateModified: null,
        isDeleted: null,
        dateDeleted: null,
        userCreated: null,
        userModified: null,
        userDeleted: null
    }
}


const newFEModel = () => {
    return {
        trudenChieusangId: null,
        soTru: null,
        tuyenDenduongId: null,
        loaiTrudenId: null,
        loaiDenId: null,
        congsuatDenId: null,
        tinhtrangDenId: null,
        tinhtrangTrudenId: null,
        gpsLong: null,
        gpsLat: null,
        ghiChu: null,
        stt: "0",
        enabled: null,
        dateCreated: null,
        dateModified: null,
        isDeleted: null,
        dateDeleted: null,
        userCreated: null,
        userModified: null,
        userDeleted: null
    }
}

const fromJson = (item) => {
    return {
        trudenChieusangId: item.trudenChieusangId,
        soTru: item.soTru,
        tuyenDenduongId: item.tuyenDenduongId,
        tenTuyenDenduong: item.tenTuyenDenduong,
        loaiTrudenId: item.loaiTrudenId,
        tenLoaiTruden: item.tenLoaiTruden,
        loaiDenId: item.loaiDenId,
        tenLoaiDen: item.tenLoaiDen,
        congsuatDenId: item.congsuatDenId,
        tenCongsuatDen: item.tenCongsuatDen,
        tinhtrangDenId: item.tinhtrangDenId,
        tenTinhtrangDen: item.tenTinhtrangDen,
        tinhtrangTrudenId: item.tinhtrangTrudenId,
        tenTinhtrangTruden: item.tenTinhtrangTruden,
        gpsLong: item.gpsLong,
        gpsLat: item.gpsLat,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
        dateCreated: item.dateCreated,
        dateModified: item.dateModified,
        isDeleted: item.isDeleted,
        dateDeleted: item.dateDeleted,
        userCreated: item.userCreated,
        userModified: item.userModified,
        userDeleted: item.userDeleted,
    }
}

const parseModeltoFEModel = (item) => {
    return {
        trudenChieusangId: item.trudenChieusangId,
        soTru: item.soTru,
        tuyenDenduongId: item.tuyenDenduongId,
        tenTuyenDenduong: item.tenTuyenDenduong,
        loaiTrudenId: item.loaiTrudenId,
        tenLoaiTruden: item.tenLoaiTruden,
        loaiDenId: item.loaiDenId,
        tenLoaiDen: item.tenLoaiDen,
        congsuatDenId: item.congsuatDenId,
        tenCongsuatDen: item.tenCongsuatDen,
        tinhtrangDenId: item.tinhtrangDenId,
        tenTinhtrangDen: item.tenTinhtrangDen,
        tinhtrangTrudenId: item.tinhtrangTrudenId,
        tenTinhtrangTruden: item.tenTinhtrangTruden,
        gpsLong: item.gpsLong,
        gpsLat: item.gpsLat,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
        dateCreated: item.dateCreated,
        dateModified: item.dateModified,
        isDeleted: item.isDeleted,
        dateDeleted: item.dateDeleted,
        userCreated: item.userCreated,
        userModified: item.userModified,
        userDeleted: item.userDeleted,
    }
}

const newPagingSearchModel = () => {
    return {
        pageNumber: null,
        pageSize: null,
        sort: null,
        soTru: null,
        tuyenDenduongId: null,
        loaiTrudenId: null,
        loaiDenId: null,
        congsuatDenId: null,
        tinhtrangDenId: null,
        tinhtrangTrudenId: null,
        chieuSang: null,
        enabled: null,
    }
}

const newSearchModel = (item) => {
    return {
        soTru: item.soTru,
        tuyenDenduongId: item.tuyenDenduongId,
        loaiTrudenId: item.loaiTrudenId,
        loaiDenId: item.loaiDenId,
        congsuatDenId: item.congsuatDenId,
        tinhtrangDenId: item.tinhtrangDenId,
        tinhtrangTrudenId: item.tinhtrangTrudenId,
        chieuSang: item.chieuSang,
        enabled: item.enabled,
    }
}

const errors = () => {
    return {
        trudenChieusangId: null,
        soTru: null,
        tuyenDenduongId: null,
        loaiTrudenId: null,
        loaiDenId: null,
        congsuatDenId: null,
        tinhtrangDenId: null,
        tinhtrangTrudenId: null,
        gpsLong: null,
        gpsLat: null,
        ghiChu: null,
        stt: null,
        enabled: null,
        enabledDisplay: null,
        dateCreated: null,
        dateModified: null,
        isDeleted: null,
        dateDeleted: null,
        userCreated: null,
        userModified: null,
        userDeleted: null 
    }
}

export const truDenChieuSangModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    fromJson,
    newPagingSearchModel,
    newSearchModel,
    errors,
}
